import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
//import Home from "../views/Home.vue";

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
  },
  {
    path: "/rent",
    name: "rent",
    component: () => import(/* webpackChunkName: "rent" */ "../views/Rent.vue"),
  },
  {
    path: "/rent-search",
    name: "rent-search",
    component: () => import(/* webpackChunkName: "rent-serch" */ "../views/RentSearch.vue"),
  },
  {
    path: "/rent-booking/:productId",
    name: "rent-booking",
    component: () => import(/* webpackChunkName: "rent-booking" */ "../views/RentBooking.vue"),
  },
  {
    path: "/rent-booking/edit/:orderrItemGroupId",
    name: "rent-booking-edit",
    component: () => import(/* webpackChunkName: "rent-booking-edit" */ "../views/RentBooking.vue"),
  },
  {
    path: "/course",
    name: "course",
    component: () => import(/* webpackChunkName: "course" */ "../views/Course.vue"),
  },
  {
    path: "/course-search",
    name: "course-search",
    component: () => import(/* webpackChunkName: "course-search" */ "../views/CourseSearch.vue"),
  },
  {
    path: "/course-private-booking/:productId",
    name: "course-private-booking",
    component: () => import(/* webpackChunkName: "course-private-booking" */ "../views/CoursePrivateBooking.vue"),
  },
  {
    path: "/course-group-booking/:productId",
    name: "course-group-booking",
    component: () => import(/* webpackChunkName: "course-group-booking" */ "../views/CourseGroupBooking.vue"),
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import(/* webpackChunkName: "cart" */ "../views/Cart.vue"),
  },
  {
    path: "/checkout-pickup",
    name: "checkout-pickup",
    component: () => import(/* webpackChunkName: "checkout-pickup" */ "../views/CheckoutPickUp.vue"),
  },
  {
    path: "/checkout-contacts",
    name: "checkout-contacts",
    component: () => import(/* webpackChunkName: "checkout-contacts" */ "../views/CheckoutContacts.vue"),
  },
  {
    path: "/checkout-payment/:paymentId",
    name: "checkout-payment",
    component: () => import(/* webpackChunkName: "checkout-payment" */ "../views/CheckoutPayment.vue"),
  },
  {
    path: "/checkout-payment-result/:id/:refId",
    name: "checkout-payment-result",
    component: () => import(/* webpackChunkName: "checkout-payment-result" */ "../views/CheckoutPaymentResult.vue"),
  },
  {
    path: "/checkout-completed/:orderrId",
    name: "checkout-completed",
    component: () => import(/* webpackChunkName: "checkout-completed" */ "../views/CheckoutCompleted.vue"),
  },
  {
    path: "/checkout-completed/:orderrId/:transId",
    name: "checkout-completed-transid",
    component: () => import(/* webpackChunkName: "checkout-completed-transid" */ "../views/CheckoutCompleted.vue"),
  },
  {
    path: "/order-history",
    name: "order-history",
    component: () => import(/* webpackChunkName: "order-history" */ "../views/OrderHistory.vue"),
  },
  {
    path: "/static-content/:staticContentId/",
    name: "static-content",
    component: () => import(/* webpackChunkName: "static-content" */ "../views/StaticContent.vue"),
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import(/* webpackChunkName: "auth" */ "../views/Auth.vue"),
  },

  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
